<svg width="140" height="89" viewBox="0 0 140 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="graphic">
        <rect width="140" height="89" rx="4" fill="currentColor"/>
        <g id="Group 780">
            <rect x="33" y="12" width="74" height="45" rx="2" fill="#C1D1DF"/>
            <rect x="8" y="65" width="27" height="14" rx="2" fill="#C1D1DF"/>
            <rect x="40" y="65" width="29" height="14" rx="2" fill="#C1D1DF"/>
            <rect x="74" y="65" width="27" height="14" rx="2" fill="#C1D1DF"/>
            <rect x="106" y="65" width="27" height="14" rx="2" fill="#C1D1DF"/>
        </g>
    </g>
</svg>
